module.exports = __webpack_public_path__ + "static/media/inventory-icon-edit.0510f7dd.svg";